<template>
  <div>
    <div class="page-header">
      <div class="page-header__block">
        <div class="page-header__nav">
          <img
            src="https://bn-visas-front.oss-cn-hangzhou.aliyuncs.com/images/visaai-logo.png"
            alt="产品LOGO"
          />
          <el-menu mode="horizontal" text-color="#000000DE" @select="handleNavSelect">
            <el-menu-item v-if="userInfo.bizRole != 'K'" index="visa">
              {{ $t('nav.visaTools') }}
            </el-menu-item>
            <el-menu-item
              v-if="userInfo.visaServiceAuth === 1"
              index="online"
              :class="{
                'is-active': activeItem === 'online',
              }"
            >
              {{ $t('nav.visaService') }}
            </el-menu-item>
            <el-menu-item
              v-if="userInfo.acquiringAuth === 1"
              index="orders"
              :class="{ 'is-active': activeItem === 'visa' && activeIndex === 'orders' }"
            >
              {{ $t('nav.acquiring') }}
            </el-menu-item>
            <el-menu-item
              v-if="channel !== 'lyb' && userInfo.insuranceAuth === 1"
              index="insurance"
              :class="{ 'is-active': activeItem === 'insurance' }"
            >
              {{ $t('nav.insurance') }}
            </el-menu-item>
            <!-- <el-menu-item
              v-if="channel !== 'lyb' && userInfo.applyVisaAuth === 1"
              index="visaApply"
              :class="{ 'is-active': activeItem === 'visaApply' }"
            >
              办理签证
            </el-menu-item> -->
            <!-- <el-menu-item
              v-if="channel !== 'lyb' && userInfo.ticketAuth === 1"
              index="planeTicket"
              :class="{ 'is-active': activeItem === 'planeTicket' }"
            >
              机票
            </el-menu-item> -->
            <el-menu-item
              v-if="
                userInfo.feizhuAuth === 1 &&
                (userInfo.bizRole == 'A' || userInfo.bizRole == 'M') &&
                channel != 'lyb'
              "
              index="fliggy-order"
            >
              {{ $t('nav.fliggyOrders') }}
            </el-menu-item>
            <el-menu-item
              v-if="channel !== 'lyb' && userInfo.orderAuth === 1"
              index="wangdan"
              :class="{ 'is-active': $route.name === 'WangdanIntroduction' }"
            >
              {{ $t('nav.wangdan') }}
            </el-menu-item>
          </el-menu>
        </div>
        <div class="page-header__info">
          <div class="page-header__info-phone">
            <img
              src="https://bn-visas-front.oss-cn-hangzhou.aliyuncs.com/images/phone.png"
              alt="联系电话"
            />
            <span>0571-87670963</span>
          </div>
          <div class="page-header__info-wechat">
            <el-popover
              placement="bottom"
              trigger="hover"
              popper-class="wechat-qr-code-popper"
            >
              <img
                src="https://bn-visas-front.oss-cn-hangzhou.aliyuncs.com/images/wechat-qr-code.png"
                alt="微信客服二维码"
              />
              <img
                slot="reference"
                src="https://bn-visas-front.oss-cn-hangzhou.aliyuncs.com/images/wechat.png"
                alt="微信"
              />
            </el-popover>
          </div>
          <div class="page-header__info-btn" @click="goDownload">
            {{ $t('nav.downloadCenter') }}
            <span class="page-header__info-btn-infoCount" v-if="downloadNum > 0">{{
              downloadNum
            }}</span>
          </div>
          <div
            class="page-header__info-btn"
            v-if="userInfo.channel !== 'lyb' && userInfo.bizRole == 'A'"
            @click="goToSystemUserPage"
          >
            {{ $t('nav.accountMgmt') }}
          </div>

          <!-- <el-dropdown>
            <div class="page-header__info-btn">公告</div>
            <el-dropdown-menu slot="dropdown" class="page-header__info-message">
              <el-dropdown-item>
                <div
                  class="page-header__info-message-item"
                  @click="goToMessagePage('SUBMITFAILURE')"
                >
                  <span>提交失败</span>
                  <span>{{ messageCount.SUBMITFAILURE || "" }}</span>
                </div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div
                  class="page-header__info-message-item"
                  @click="goToMessagePage('UNPAIDMONEY')"
                >
                  <span>待支付领馆费用</span>
                  <span>{{ messageCount.UNPAIDMONEY || "" }}</span>
                </div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div
                  class="page-header__info-message-item"
                  @click="goToMessagePage('COMEVISA')"
                >
                  <span>出签</span>
                  <span>{{ messageCount.COMEVISA || "" }}</span>
                </div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div
                  class="page-header__info-message-item"
                  @click="goToMessagePage('REJECTVISA')"
                >
                  <span>拒签</span>
                  <span>{{ messageCount.REJECTVISA || "" }}</span>
                </div>
              </el-dropdown-item>
              <el-dropdown-item divided>
                <div class="page-header__info-message-item">
                  <el-button type="text" @click="setAllMessageToRead"
                    >全部标记为已读</el-button
                  >
                  <el-button type="text" @click="goToMessagePage()">查看全部</el-button>
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown> -->

          <el-dropdown :hide-on-click="false" @visible-change="getUserBalance">
            <div class="page-header__info-btn" v-show="userInfo.bizRole != 'K'">{{ $t('nav.finance') }}</div>
            <el-dropdown-menu
              slot="dropdown"
              class="page-header__info-wallet"
            >
              <el-dropdown-item>
                <div class="page-header__info-wallet-item">
                  <p class="page-header__info-wallet-name">
                    {{ $t('nav.couponAccount') }}
                  </p>
                  <div class="page-header__info-wallet-amount">
                    <span>
                      <span
                        class="page-header__info-wallet-value"
                        style="color: rgba(200, 150, 88, 1)"
                        >{{ balance.score | filterToYuan }} {{ $t('nav.couponUnit') }}</span
                      >
                    </span>
                    <div class="page-header__info-wallet-actions">
                      <el-button
                        type="primary"
                        style="width: 60px !important; color: #fff"
                        @click="goToFinancialPage('/financial/recharge')"
                        >{{ $t('nav.recharge') }}</el-button
                      >
                      <el-button
                        plain
                        v-if="userInfo.bizRole === 'A'"
                        @click="goToFinancialPage('/financial/coupon')"
                        >{{ $t('nav.accountDetail') }}</el-button
                      >
                    </div>
                  </div>
                </div>
              </el-dropdown-item>

              <el-dropdown-item>
                <div class="page-header__info-wallet-item">
                  <p class="page-header__info-wallet-name">{{ $t('nav.shanfuAccount') }}</p>
                  <div class="page-header__info-wallet-amount">
                    <span>
                      <span
                        class="page-header__info-wallet-value"
                        style="color: rgba(255, 111, 0, 1)"
                        >{{ merBalance | filterToYuan }} {{ $t('nav.yuan') }}</span
                      >
                    </span>
                    <div class="page-header__info-wallet-actions">
                      <el-button
                        type="primary"
                        style="width: 60px !important; color: #fff"
                        @click="goToMerchant('recharge')"
                        >{{ $t('nav.recharge') }}</el-button
                      >
                      <el-button plain @click="goToMerchant('sheet')"
                        >{{ $t('nav.accountDetail') }}</el-button
                      >
                    </div>
                  </div>
                </div>
              </el-dropdown-item>

              <el-dropdown-item v-if="userInfo.insuranceAuth === 1">
                <div class="page-header__info-wallet-item">
                  <p class="page-header__info-wallet-name">
                    {{ $t('nav.insuranceAccount') }}
                  </p>
                  <div class="page-header__info-wallet-amount">
                    <span>
                      <span
                        class="page-header__info-wallet-value"
                        style="color: rgba(255, 111, 0, 1)"
                        >{{ bxBalance | filterToYuan }} {{ $t('nav.yuan') }}</span
                      >
                    </span>
                    <div class="page-header__info-wallet-actions">
                      <el-button
                        type="primary"
                        style="width: 60px !important; color: #fff"
                        @click="goBxToMerchant('recharge')"
                        >{{ $t('nav.recharge') }}</el-button
                      >
                      <el-button plain @click="goBxToMerchant('detail')"
                        >{{ $t('nav.accountDetail') }}</el-button
                      >
                    </div>
                  </div>
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown class="page-header__info-account">
            <img
              src="https://bn-visas-front.oss-cn-hangzhou.aliyuncs.com/images/user.png"
              alt="账号"
            />
            <el-dropdown-menu slot="dropdown" class="page-header__info-account-list">
              <el-dropdown-item>
                <div class="page-header__info-account-name">
                  <p>{{ userInfo.nick }} ({{ userInfo.loginAccount }})</p>
                  <p>
                    {{ userInfo.companyName }}
                  </p>
                </div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div @click="showModifyLoginAccountDialog = true">
                  <el-button type="text">{{ $t('nav.editPassword') }}</el-button>
                </div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div @click="handleAccountLogout">
                  <el-button type="text">{{ $t('nav.logout') }}</el-button>
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>

    <coupon-recharge-dialog
      :show.sync="showCouponRechargeDialog"
    ></coupon-recharge-dialog>
    <visa-fee-recharge-dialog
      :accountType="visaFeeRechargeType"
      :show.sync="showVisaFeeRechargeDialog"
    ></visa-fee-recharge-dialog>
    <mall-recharge-dialog
      :balance="balance.mallBalance"
      :show.sync="showMallRechargeDialog"
    ></mall-recharge-dialog>
    <modify-login-password-dialog
      :show.sync="showModifyLoginAccountDialog"
    ></modify-login-password-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import * as messageApi from "@/apis/message";
import * as financialApi from "@/apis/financial";
import * as accountApi from "@/apis/account";
import * as toolApi from "@/apis/tool";
import CouponRechargeDialog from "@/components/CouponRechargeDialog";
import VisaFeeRechargeDialog from "@/components/VisaFeeRechargeDialog";
import MallRechargeDialog from "@/components/MallRechargeDialog";
import ModifyLoginPasswordDialog from "@/components/ModifyLoginPasswordDialog";
import { getWebURL, getPageURL, getLocationSearch, getCookie } from "@/utils/util";
import { appendShanfuAuthQuery } from "@/i18n/cross-app-query";
export default {
  name: "pageHeader",
  components: {
    CouponRechargeDialog,
    VisaFeeRechargeDialog,
    MallRechargeDialog,
    ModifyLoginPasswordDialog,
  },
  data() {
    return {
      messageCount: {
        ANNOUNCEMENT: 0,
        SUBMITFAILURE: 0,
        UNPAIDMONEY: 0,
        COMEVISA: 0,
        REJECTVISA: 0,
      },
      showCouponRechargeDialog: false,
      showVisaFeeRechargeDialog: false,
      showMallRechargeDialog: false,
      visaFeeRechargeType: "",
      isUSARechargeClose: false,
      isMalayRechargeClose: false,
      showModifyLoginAccountDialog: false,
      accountAuth: {},
      merBalance: 0,
      bxBalance: 0,
      rechargeData: {
        type: "",
        balance: 0,
      },
    };
  },
  computed: {
    ...mapGetters(["userInfo", "balance", "downloadNum"]),
    channel() {
      return this.userInfo.channel || "";
    },
    themeColor() {
      if (this.channel === "lyb") {
        return "#FF9300";
      } else {
        return "#00BF94";
      }
    },
    activeItem() {
      let activeItem = "";
      const [path, query] = decodeURIComponent(this.$route.fullPath).split("?");
      console.log(path, query, "query");

      const { name } = this.$route;
      if (path === "/web/mall") {
        if (query) {
          if (query.includes("insurance")) {
            activeItem = "insurance";
          } else if (query.includes("airport-service")) {
            activeItem = "airportService";
          }
        } else {
          activeItem = "insurance";
        }
      } else if (path === "/web/ticket") {
        activeItem = "planeTicket";
      } else if (path === "/web/online") {
        activeItem = "online";
      }
      return activeItem;
    },
  },
  mounted() {
    this.getAccountAuth();
    this.getMessageCount();
    this.getVisaFeeConfig();
    this.getDownloadList();
    this.getUserBalance();
    window.addEventListener("message", this.handleMessagePost);
  },
  destroyed() {
    window.removeEventListener("message", this.handleMessagePost);
  },
  methods: {
    ...mapActions(["setBalance", "setDownloadNum"]),
    goDownload() {
      window.open(getWebURL("visa") + "/downloadPage");
      // location.href = getWebURL("visa") + "/downloadPage";
    },
    async getDownloadList() {
      try {
        const result = await toolApi.listDownloadList({
          pageNum: 1,
          pageSize: 100,
        });
        if (result.records && result.records.length > 0) {
          let count = 0;
          result.records.forEach((item) => {
            // count = count + 1;
            if (item.status == "DOING") {
              count = count + 1;
            }
            if (item.status == "SUCCESS" && item.downloadStatus == 0) {
              count = count + 1;
            }
          });
          setTimeout(() => {
            this.setDownloadNum(count);
          }, 100);
        }
      } catch (e) {
        console.log(e, "e");
      }
    },
    async getMerchantBalance() {
      try {
        const result = await financialApi.getMerchantBalance();
        if (result || result === 0) {
          this.merBalance = result;
        }
      } catch (e) {
        console.log(e, "getMerchantBalance");
      }
    },
    async getInsuranceBalance() {
      try {
        const result = await financialApi.getInsuranceCompanyBalance();
        this.bxBalance = result && result.balance;
      } catch (e) {
        console.log(e, "getInsuranceBalance");
      }
    },
    getUserBalance() {
      this.getMerchantBalance();
      this.getInsuranceBalance();
      this.setBalance();
    },
    async getAuthUrls() {
      return financialApi.getAuthUrl();
    },
    async resolveVccOnlineRechargeForShanfu() {
      let value = this.userInfo && this.userInfo.vccOnlineRecharge;
      if (value === undefined || value === null) {
        value = this.accountAuth && this.accountAuth.vccOnlineRecharge;
      }
      if (value !== undefined && value !== null) {
        return value;
      }
      try {
        const result = await accountApi.getAccountAuth();
        value = result && result.vccOnlineRecharge;
        if (result) {
          this.accountAuth = result;
        }
      } catch (e) {
        console.log(e, "resolveVccOnlineRechargeForShanfu");
      }
      return value;
    },
    async goToMerchant(type) {
      const url =
        type == "recharge"
          ? "#/finance/financeIndex/recharge"
          : type == "home"
          ? "#/home"
          : "#/finance/financeIndex";
      try {
        const authurl = await this.getAuthUrls();
        if (!authurl) {
          return;
        }
        const authUrlObj = new URL(authurl);
        const vccOnlineRecharge = await this.resolveVccOnlineRechargeForShanfu();
        const search = appendShanfuAuthQuery(authUrlObj.search || "", {
          vccOnlineRecharge,
          locale: this.$i18n && this.$i18n.locale,
        });
        const hostname = location.hostname;
        if (hostname === "localhost" || hostname === "127.0.0.1") {
          const localBase = getPageURL("shanfu").replace(/\/$/, "");
          window.open(`${localBase}${search}${url}`);
          return;
        }
        window.open(`${authUrlObj.origin}${authUrlObj.pathname}${search}${url}`);
      } catch (e) {
        console.log(e, "goToMerchant");
      }
    },
    goBxToMerchant(type) {
      const cookie = getCookie();
      const sessionId =
        (cookie.userInfo && cookie.userInfo.sessionId) ||
        (this.userInfo && this.userInfo.sessionId) ||
        "";
      const isNewTest = window.location.href.includes("newTest");
      if (isNewTest) {
        window.open(
          `http://h5-visas-mall.qa.visaapp6.com/?mode=newTest&sessionid=${sessionId}#/financial/${type}`
        );
      } else {
        window.open(
          `https://jdal.meditrustbroker.com/?sessionid=${sessionId}#/financial/${type}`
        );
      }
    },
    handleMessagePost(e) {
      if (e.type === "message") {
        switch (e.data.type) {
          case "MALL_RECHARGE": // 现金账户充值
            this.handleMallRecharge();
            break;
          default:
            break;
        }
      }
    },
    async getAccountAuth() {
      const result = await accountApi.getAccountAuth();
      if (result) {
        this.accountAuth = result;
      }
    },
    async getMessageCount() {
      const result = await messageApi.getMessageCount();
      if (result) {
        this.messageCount = {
          ...this.messageCount,
          result,
        };
      }
    },
    async setAllMessageToRead() {
      const result = await messageApi.setAllMessageToRead();
      if (result) {
        this.getMessageCount();
      }
    },
    goToMessagePage(type) {
      this.$router.push({
        name: "MessageList",
        query: { type },
      });
    },
    async getVisaFeeConfig() {
      const result = await financialApi.getVisaFeeConfig();
      if (result) {
        this.isUSARechargeClose = result.isCloseUsVisaRecharge;
        this.isMalayRechargeClose = result.isCloseMalaysiaEntriRecharge;
      }
    },
    goToFinancialPage(path) {
      this.$router.push(path);
    },
    handleVisaFeeRecharge(type) {
      if (type === "USA" && this.isUSARechargeClose) {
        return;
      }
      if (type === "MALAY" && this.isMalayRechargeClose) {
        return;
      }
      this.visaFeeRechargeType = type;
      this.showVisaFeeRechargeDialog = true;
    },
    async handleAccountLogout() {
      const search = getLocationSearch();
      if (!search.sessionId && !search.safari) {
        // 非免登账号，才能使用登出功能
        await accountApi.accountLogout();
      }
      location.href = getWebURL("visa") + "/login";
    },
    handleNavSelect(index) {
      switch (index) {
        case "visa":
          location.href = getWebURL("visa") + "/country";
          break;
        case "online":
          location.href = getWebURL("visa") + "/onlineServe";
          break;
        case "visaApply":
          location.href = getWebURL("visa") + "/visa-apply";
          break;
        case "orders":
          location.href = getWebURL("visa") + "/tbrorderdata/tbrOrder0";
          break;
        case "insurance":
          location.href = getWebURL("platform") + "/web/mall";
          break;
        case "planeTicket":
          location.href = getWebURL("platform") + "/web/ticket";
          break;
        case "wangdan":
          if (this.userInfo.orderAuth == 1) {
            location.href = getWebURL("wangdan") + "/";
          } else {
            this.$router.push({ name: "WangdanIntroduction" });
          }
          break;
        case "fliggy-order":
          location.href = getWebURL("visa") + "/fliggy-order";
          break;
        default:
          this.$router.push({
            name: index,
          });
          break;
      }
    },
    handleMallRecharge() {
      this.showMallRechargeDialog = true;
    },
    goToSystemUserPage() {
      location.href = getWebURL("visa") + "/basic-config/system-user";
    },
  },
};
</script>

<style lang="scss">
.flexWrap {
  width: 100%;
  padding: 16px 0;
  display: flex;
  justify-content: center;
}
.page-header {
  background-color: $color-white;
  height: 70px;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.12);
  position: relative;
  z-index: 100;

  &__block {
    min-width: 1260px;
    max-width: 1980px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    margin: 0 auto;
    box-sizing: border-box;
  }
  &__nav {
    display: flex;
    align-items: center;
    img {
      width: 100px;
      height: 40px;
      margin-right: 50px;
    }
    .el-menu-item.is-active {
      color: rgb(0, 191, 148) !important;
      border-bottom-color: rgb(0, 191, 148) !important;
    }
    .el-menu--horizontal.el-menu {
      height: 70px;
      border: none;
    }
    .el-menu--horizontal.el-menu .el-menu-item {
      height: 70px;
      line-height: 70px;
      border-bottom-width: 4px;
      padding-left: 15px;
      padding-right: 15px;
      font-size: 16px;
      font-weight: 500;
      &:hover {
        color: $color-green-dark;
      }
    }
    .el-menu--horizontal > .el-submenu .el-submenu__title {
      height: 70px;
      line-height: 70px;
      border-bottom-width: 4px !important;
      padding-left: 15px;
      padding-right: 15px;
      &:hover {
        color: $color-green-dark;
      }
    }
  }
  &__info {
    display: flex;
    align-items: center;
    &-phone {
      padding-right: 16px;
      line-height: 28px;
      img {
        width: 14px;
        height: 14px;
        margin-right: 8px;
      }
      span {
        color: $color-green-dark;
        font-size: 18px;
      }
    }
    &-wechat {
      padding-left: 16px;
      padding-right: 30px;
      border-left: 1px solid $color-border;
      height: 18px;
      line-height: 18px;
      img {
        width: 18px;
        height: 15px;
      }
    }
    &-btn {
      position: relative;
      padding-right: 20px;
      color: $color-black-87;
      font-weight: 500;
      font-size: 16px;
      line-height: 26px;
      cursor: pointer;

      &-infoCount {
        position: absolute;
        background: red;
        border-radius: 14px;
        color: #fff;
        top: 0px;
        right: 8px;
        width: 14px;
        height: 14px;
        line-height: 14px;
        text-align: center;
        font-size: 12px;
      }
    }
    &-message {
      padding: 6px 0 !important;
      &-item {
        width: 190px;
        height: 30px;
        line-height: 30px;
        font-size: 12px;
        display: flex;
        justify-content: space-between;
      }
      .el-button--text {
        font-size: 12px;
        padding: 0;
      }
      .el-dropdown-menu__item--divided {
        height: 30px;
        line-height: 30px;
        margin-top: 0;
        &::before {
          height: 1px;
        }
      }
    }
    &-wallet {
      padding: 6px 0 !important;
      .el-dropdown-menu__item {
        cursor: default;
      }
      &-item {
        width: 280px;
        line-height: 20px;
        font-size: 12px;
        padding-top: 8px;
      }
      &-name {
        margin-top: 0;
        color: $color-black-54;
        // margin-bottom: 8px;
      }
      &-amount {
        color: $color-black-54;
        padding-bottom: 8px;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      &-value {
        font-size: 14px;
        color: $color-black;
        // padding-left: 8px;
      }
      &-country {
        color: $color-black-87;
        width: 60px;
        display: inline-block;
      }
      &-actions {
        .el-button {
          width: 88px !important;
          height: 36px !important;
          padding: 0;
          margin: 0;
          line-height: 24px;
          font-size: 10px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.6);
          border-radius: 2px;
          & + .el-button {
            margin-left: 4px;
          }
        }
      }
      .el-dropdown-menu__item--divided {
        margin-top: 0;
        &::before {
          height: 1px;
        }
      }
    }
    &-language {
      position: relative;
      padding-left: 20px;
      margin-left: 20px;
      &:before {
        content: "";
        position: absolute;
        left: 0;
        top: -6px;
        bottom: -6px;
        border-left: 1px solid $color-border;
      }
    }
    &-account {
      padding-left: 20px;
      border-left: 1px solid $color-border;
      height: 36px;
      line-height: 36px;
      img {
        margin-top: 6px;
        width: 24px;
        height: 24px;
        cursor: pointer;
      }
      &-list {
        .el-button--text {
          font-size: 12px;
        }
      }
      &-name {
        padding: 2px 0;
        p {
          max-width: 150px;
          margin: 0;
          line-height: 20px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          &:first-child {
            color: $color-black-87;
          }
        }
      }
    }
  }
}
.el-popover.wechat-qr-code-popper {
  padding: 0;
  min-width: 0;
  line-height: 0;
  img {
    width: 60px;
    height: 60px;
  }
}
</style>
